export class PermissionAccessLevel {
	private static re = new RegExp(/\[ENV\]/);
	private _credGroupName: string;
	private _label: string;
	private _accessLevel: number;
	private _defaultGroup: boolean;
	private _ext: any = { };

	constructor(private _permissionName: string, permissionGrouping: any, envName: string) {
		this._credGroupName = permissionGrouping.groupName.replace(PermissionAccessLevel.re, envName);
		this._label = permissionGrouping.label;
		this._accessLevel = permissionGrouping.accessLevel;
		this._defaultGroup = permissionGrouping.defaultGroup || false;
	}

	get groupName(): string {
		return this._credGroupName;
	}

	get label(): string {
		return this._label;
	}

	get accessLevel(): number {
		return this._accessLevel;
	}

	get permissionName(): string {
		return this._permissionName;
	}

	get fullName(): string {
		return `${this._permissionName}.${this._label}`;
	}

	get ext(): any {
		return this._ext;
	}

	set ext(newExt: any) {
		this._ext = newExt;
	}

	get defaultGroup(): boolean {
		return this._defaultGroup;
	}
}
